import camelCase from 'lodash/camelCase';
import isArray from 'lodash/isArray';
import last from 'lodash/last';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';

import { IArrayError, IError, IProblem, ISubmissionError } from './types';

const MESSAGES: Record<string, string> = {
  'Expected value to not be null': 'is required',
  default: 'is not valid',
};

const pathsToFieldName = (paths: string[]): string => paths.map(camelCase).join('.');
const explanationToMessage = (explanation: string): string =>
  MESSAGES[explanation] || MESSAGES.default;

const extractFieldNameAndExplanation = (
  fields: ISubmissionError,
  { path, explanation }: IProblem
): ISubmissionError => ({
  ...fields,
  [pathsToFieldName(path)]: explanationToMessage(explanation),
});

const flattenProblemsToFieldMapping = (problems: IProblem[] = []): ISubmissionError =>
  problems.reduce<ISubmissionError>(extractFieldNameAndExplanation, {});

export const flattenErrorMessages = (errors: IError): ISubmissionError =>
  mapValues(
    mapKeys(errors, (_v, k) => camelCase(last(k.split('.')))),
    (value) => value[0]
  );

export default (errors: IArrayError[] | IError): ISubmissionError => {
  // Graphql returns different format of errors depending on the origin of the error (scalar typecheck vs reform)
  if (isArray(errors)) {
    return (errors as IArrayError[]).reduce<ISubmissionError>(
      (errorMap, { problems }) => ({
        _error: '1 or more fields are invalid',
        ...errorMap,
        ...flattenProblemsToFieldMapping(problems),
      }),
      {}
    );
  }

  return {
    _error: '1 or more fields are invalid',
    ...flattenErrorMessages(errors),
  };
};
